export default {
    es: {
        userAdmin: {
            title: 'Crear usuario',
            subtitle: 'Solo disponible para superusuarios',
            username: 'Nombre de usuario',
            email: 'Correo electrónico',
            firstName: 'Nombres',
            lastName: 'Apellidos',
            password: 'Contraseña',
            passwordConfirm: 'Confirmar contraseña',
            company: 'Empresa',
            preferredLanguage: 'Idioma',
            isActive: 'Cuenta activa',
            isStaff: 'Staff',
            isSuperuser: 'Superusuario',
            isCompanyAdmin: 'Administrador de empresa',
            submit: 'Crear usuario',
            created: 'Usuario creado exitosamente',
            required: 'Este campo es obligatorio',
            passwordsDoNotMatch: 'Las contraseñas no coinciden',
            passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
            loadCompaniesError: 'No se pudieron cargar las empresas'
        }
    },
    en: {
        userAdmin: {
            title: 'Create user',
            subtitle: 'Superuser only',
            username: 'Username',
            email: 'Email',
            firstName: 'First name',
            lastName: 'Last name',
            password: 'Password',
            passwordConfirm: 'Confirm password',
            company: 'Company',
            preferredLanguage: 'Language',
            isActive: 'Active account',
            isStaff: 'Staff',
            isSuperuser: 'Superuser',
            isCompanyAdmin: 'Company admin',
            submit: 'Create user',
            created: 'User created successfully',
            required: 'This field is required',
            passwordsDoNotMatch: 'Passwords do not match',
            passwordTooShort: 'Password must be at least 8 characters long',
            loadCompaniesError: 'Could not load companies'
        }
    },
    fr: {
        userAdmin: {
            title: 'Créer un utilisateur',
            subtitle: 'Réservé aux superutilisateurs',
            username: "Nom d'utilisateur",
            email: 'E-mail',
            firstName: 'Prénom',
            lastName: 'Nom',
            password: 'Mot de passe',
            passwordConfirm: 'Confirmer le mot de passe',
            company: 'Entreprise',
            preferredLanguage: 'Langue',
            isActive: 'Compte actif',
            isStaff: 'Staff',
            isSuperuser: 'Superutilisateur',
            isCompanyAdmin: "Administrateur d'entreprise",
            submit: 'Créer un utilisateur',
            created: 'Utilisateur créé avec succès',
            required: 'Ce champ est obligatoire',
            passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
            passwordTooShort: 'Le mot de passe doit comporter au moins 8 caractères',
            loadCompaniesError: 'Impossible de charger les entreprises'
        }
    }
}
